const commonConfig = {
  CryptoKey: "dcuhv8zfgn12iaxq9ej45wklbsy3ro07",
};
export default [
  {
    name: "CA",
    config: {
      ...commonConfig,
      gateway: "https://alica-gateway.fantuan.ca",
    },
  },
  {
    name: "US",
    config: {
      ...commonConfig,
      gateway: "https://alius-gateway.fantuan.ca",
    },
  },
  {
    name: "AU",
    config: {
      ...commonConfig,
      gateway: "https://aliau-gateway.fantuan.ca",
    },
  },
  {
    name: "GB",
    config: {
      ...commonConfig,
      gateway: "https://aliuk-gateway.fantuan.ca",
    },
  },
  {
    name: "FR",
    disabled: true,
    config: {
      ...commonConfig,
      gateway: "https://alifr-gateway.fantuan.ca",
    },
  },
  {
    name: "NZ",
    disabled: true,
    config: {
      ...commonConfig,
      gateway: "https://alinz-gateway.fantuan.ca",
    },
  },
  {
    name: "TH",
    disabled: true,
    config: {
      ...commonConfig,
      gateway: "https://alith-gateway.fantuan.ca",
    },
  },
  {
    name: "MY",
    disabled: true,
    config: {
      ...commonConfig,
      gateway: "https://alimy-gateway.fantuan.ca",
    },
  },
  {
    name: "JP",
    disabled: true,
    config: {
      ...commonConfig,
      gateway: "https://alijp-gateway.fantuan.ca",
    },
  },
  {
    name: "KR",
    disabled: true,
    config: {
      ...commonConfig,
      gateway: "https://alikr-gateway.fantuan.ca",
    },
  },
  {
    name: "SG",
    disabled: true,
    config: {
      ...commonConfig,
      gateway: "https://alisg-gateway.fantuan.ca",
    },
  },
];
